<div class="phx-time-range-picker">
  <phx-tile
    [phxClickable]="true"
    [phxBorder]="true"
    [phxBorderStates]="true"
    [phxIsUsedAsSelector]="true"
    [phxSelected]="isInFilterRow && phxValue && !isDefaultSelection"
    [phxSize]="phxSize"
    [phxDropdownFor]="phxDropdown"
    [phxDisabled]="phxDisabled"
    [phxHasError]="shouldShowError"
    (phxVisibleChange)="onVisibleChange($event)"
    (blur)="onBlur()"
    phxTrigger="click"
  >
    <i phx-tile-prefix phx-icon [phxIcon]="clockIcon" color="currentColor"></i>
    <span *ngIf="phxIsRangeEnabled">
      <ng-container *ngIf="phxValue && phxValue[0] && phxValue[1]; else noValueRange">
        <span class="phx-time-picker-text" phxText>
          {{ formatDateToTimeString(phxValue[0]) || "Start Time" }} - {{ formatDateToTimeString(phxValue[1]) || "End Time" }}
        </span>
      </ng-container>
      <ng-template #noValueRange>
        <span class="phx-time-picker-text">{{ phxPlaceholder || "Time-range" }}</span>
      </ng-template>
    </span>
    <ng-container *ngIf="!phxIsRangeEnabled">
      <span *ngIf="phxValue; else noValue" class="phx-time-picker-text" phxText>{{ formatDateToTimeString(phxValue) }}</span>
      <ng-template #noValue>
        <span class="phx-time-picker-text">{{ phxPlaceholder || "Time" }}</span>
      </ng-template>
    </ng-container>
    <i phx-tile-suffix phx-icon [phxIcon]="chevronDown" color="currentColor"></i>
  </phx-tile>
  <phx-dropdown #phxDropdown>
    <div class="phx-time-picker-range">
      <div class="phx-time-picker-section phx-time-picker-start">
        <phx-time-picker-panel
          id="start-time"
          [phxTimePickerFormat]="effectiveTimePickerFormat"
          [phxShowInput]="phxShowInput"
          [phxValue]="phxIsRangeEnabled ? phxValue && phxValue[0] : phxValue"
          [phxDisableBefore]="phxDisableBefore"
          [phxDisableAfter]="phxDisableAfter"
          [phxInputSuffix]="phxInputSuffix"
          [phxDisabledHours]="phxDisabledHours"
          [phxDisabledMinutes]="phxDisabledMinutes"
          [phxIsDropdownOpen]="isDropdownOpen"
          (phxValueChange)="onStartTimeChange($event)"
        ></phx-time-picker-panel>
      </div>
      <div class="phx-time-picker-section phx-time-picker-end" *ngIf="phxIsRangeEnabled">
        <phx-time-picker-panel
          id="end-time"
          [phxTimePickerFormat]="effectiveTimePickerFormat"
          [phxShowInput]="phxShowInput"
          [phxValue]="phxValue && phxValue[1]"
          [phxDisableBefore]="phxDisableBefore"
          [phxDisableAfter]="phxDisableAfter"
          [phxInputSuffix]="phxInputSuffix"
          [phxDisabledHours]="phxDisabledHours"
          [phxDisabledMinutes]="phxDisabledMinutes"
          [phxIsDropdownOpen]="isDropdownOpen"
          (phxValueChange)="onEndTimeChange($event)"
        ></phx-time-picker-panel>
      </div>
    </div>
    <div *ngIf="phxValue || !isDefaultSelection" (click)="(phxDefaultSelection && !isDefaultSelection) ? onReset() : onClear()" class="phx-time-picker-panel-clear phx-web-type-body-medium">
      <span>{{ (phxDefaultSelection && !isDefaultSelection) ? 'Reset' : 'Clear' }}</span>
    </div>
  </phx-dropdown>
</div>
